import { Stack } from '@mui/material';
import FormDialog from '../form/form-dialog';
import FormInput from '../form/form-input';
import http from '../utils/http';
import useForm from '../hooks/useForm'

import { isEmpty } from 'lodash';
import React from 'react';

const AcceptedDomainAddModal = (props) => {
    const {
        state,
        onChange,
        onChangeBulk,
        onInvalidForm,
        onResetFormErrors
    } = useForm({
        debug: true,
        initialState: {
            acceptedDomain: '',
        }
    });
    const {
        config,
        isOpen,
        onChangeBulk: parentOnChangeBulk,
        environmentId,
    } = props;
    return (
        <FormDialog
            dialogTitle={'Add New Accepted Domain'}
            dialogSubHeading={'Add a new application domain that this app will be the primary referer'}
            handleClose={() => {
                onResetFormErrors();
                onChangeBulk({
                    acceptedDomain: '',
                })
                parentOnChangeBulk({ acceptedDomainAddModalIsOpen: false })
            }}
            handleSubmit={async () => {
                const errors = {};
                if (!state.values.acceptedDomain) errors.acceptedDomain = 'You must supply a valid http/https URL';

                if (!isEmpty(errors)) return onInvalidForm(errors);

                const application = await http.post({
                    acceptedDomain: state.values.acceptedDomain,
                }, `${config.uri.base}/environment/${environmentId}/domain`);

                onChangeBulk({
                    acceptedDomain: '',
                });

                parentOnChangeBulk({
                    acceptedDomainAddModalIsOpen: false,
                    application: application,
                    environments: application.environments,
                });
            }}
            isOpen={isOpen}
        >
            <Stack direction='column'>
                <FormInput
                    label='Accepted Domain'
                    path='acceptedDomain'
                    value={state.values.acceptedDomain}
                    error={state.errors.acceptedDomain}
                    onChange={(value, path) => {
                        onChange(value, path);
                    }}
                />
            </Stack>
        </FormDialog>
    );
}

export default AcceptedDomainAddModal;
